import React from "react";
import { Fragment } from "react";

export default function ServiceLogDetailHeader() {
  return (
    <Fragment>
      <div className="row customers">
        <div className="col-sm-12">
          <h2>Service Logs Route Details</h2>
        </div>
      </div>
    </Fragment>
  );
}
